import React, { useCallback, useEffect } from "react";
import { useOidc } from "@axa-fr/react-oidc";
import styles from "./Authentication.module.scss";
import { resetCurrentUser } from "services/currentUserService";
import { clearSessionPeriod } from "services/transactionPeriodService";

const Logout = () => {
  const { logout } = useOidc();

  const handleLogout = useCallback(() => {
    resetCurrentUser();
    clearSessionPeriod();
    logout("/");
  }, [logout]);

  useEffect(() => {
    handleLogout();
  }, [handleLogout]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src="/process.svg" alt="Signing out" className={styles.image} />
        <h1 className={styles.heading}>Signing you out</h1>
        <p className={styles.subtext}>
           Completing logout. You will be redirected shortly.
        </p>
      </div>
    </div>
  );
};

export default Logout;

